import { Helmet } from "react-helmet-async";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": ["LocalBusiness", "SoftwareService"],
  "@id": "https://oakyaitservices.com/#organization",
  "name": "Oakya IT Services",
  "url": "https://oakyaitservices.com/",
  "logo": "https://oakyaitservices.com/logo.png",
  "image": "https://oakyaitservices.com/logo.png",
  "description":
    "Oakya IT Services is a leading software company in Vijayawada offering software development, website development, mobile app development, digital marketing, SEO, branding, ecommerce development and 3D animation services.",

  "telephone": "+91 9134747474",
  "email": "info@oakyaitservices.com",
  "priceRange": "$$",

  "address": {
    "@type": "PostalAddress",
    "streetAddress":
      "4th Floor, MKR Enclave, Kamayyathopu, Pantakaluva Road, NTR Marg, Kanuru",
    "addressLocality": "Vijayawada",
    "addressRegion": "Andhra Pradesh",
    "postalCode": "520007",
    "addressCountry": "IN"
  },

  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 16.486356221534106,
    "longitude": 80.68583510035482
  },

  "areaServed": [
    {
      "@type": "City",
      "name": "Vijayawada"
    },
    {
      "@type": "State",
      "name": "Andhra Pradesh"
    },
    {
      "@type": "Country",
      "name": "India"
    }
  ],

  "sameAs": [
    "https://www.facebook.com/oakyaitservices",
    "https://www.linkedin.com/company/oakyaitservices",
    "https://www.instagram.com/oakyaitservices"
  ],

  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "opens": "09:30",
    "closes": "18:30"
  },

  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+91 9134747474",
    "contactType": "Customer Support",
    "areaServed": "IN",
    "availableLanguage": ["English", "Telugu"]
  },

  "keywords": [
    "Software Development",
    "Website Development",
    "Web Design",
    "Mobile App Development",
    "Digital Marketing",
    "SEO",
    "Branding",
    "Ecommerce Development",
    "WordPress Development",
    "UI UX Design",
    "Graphic Design",
    "3D Animation"
  ],

  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Oakya IT Services",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Software Development"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Website Development"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Mobile App Development"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "WordPress Development"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Digital Marketing"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "SEO"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Branding"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "E-Commerce Development"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Graphic Design"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "3D Animation"
        }
      }
    ]
  }
};

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": "https://oakyaitservices.com/#website",
  "url": "https://oakyaitservices.com/",
  "name": "Oakya IT Services",
  "publisher": {
    "@id": "https://oakyaitservices.com/#organization"
  },
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://oakyaitservices.com/?s={search_term_string}",
    "query-input": "required name=search_term_string"
  }
};

export default function Schema() {
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>

      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
    </Helmet>
  );
}